import { useState } from 'react';
import ActionLink from '../../../Components/Dashboard/ActionLink';
import { useUser } from '../../../Context/useUser';
import useDashboardSubject from '../../../Hooks/useDashboardSubject';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import DashboardRoot from '../../../Components/Dashboard/DashboardRoot';
import PageHead from '../../../Components/Dashboard/PageHead';
import DashboardGrid, { Row } from '../../../Components/Dashboard/DashboardGrid';
import { formatShortDate } from '../../../Utils/dates/formatDate';
import useAthleteWorkouts from './useAthleteWorkouts';
import NextWorkoutCard from './nextWorkout/NextWorkoutCard';
import WeeklyLoadCard from './weeklyLoad/WeeklyLoadCard';
import PastWorkoutsCard from './pastWorkouts/PastWorkoutsCard';
import TrainingRhythmCard from './trainingRhythm/TrainingRhythmCard';
import TrainingZonesCard from './zones/TrainingZonesCard';
import SwimmingStylesCard from './zones/SwimmingStylesCard';
import ZonePacesCard from './zones/ZonePacesCard';

export default function DashboardPage({ now: nowProp }) {
    const { user } = useUser();
    const { id: athleteId, isVisit } = useDashboardSubject('athlete');
    const visited = useVisitingUser(isVisit ? athleteId : null);
    // One fixed 'now' per mount: a new Date each render would change the hook's range and refetch forever.
    const [mountedAt] = useState(() => new Date());
    const now = nowProp || mountedAt;
    const workouts = useAthleteWorkouts(athleteId, now);

    const base = isVisit ? `/athlete/${athleteId}` : '';
    const css = (isVisit ? visited : user)?.currentCSS ?? null;

    return (
        <DashboardRoot>
            <PageHead
                crumb={`Athlete · ${formatShortDate(now)} ${now.getFullYear()}`}
                title="Today & this week"
                actions={<ActionLink to={`${base}/tests`}>Log test</ActionLink>}
            />
            <DashboardGrid
                fold={<NextWorkoutCard athleteId={athleteId} now={nowProp} calendarPath={`${base}/calendar`} />}
                stack={[
                    <WeeklyLoadCard key="week" workouts={workouts} now={now} css={css} />,
                    <PastWorkoutsCard key="past" workouts={workouts} now={now} calendarPath={`${base}/calendar`} />
                ]}
            />
            <Row>
                <TrainingRhythmCard workouts={workouts} now={now} performancePath={`${base}/performance`} />
                <TrainingZonesCard athleteId={athleteId} now={nowProp} />
            </Row>
            <Row even>
                <SwimmingStylesCard athleteId={athleteId} now={nowProp} />
                <ZonePacesCard css={css} testsPath={`${base}/tests`} />
            </Row>
        </DashboardRoot>
    );
}
